import { render } from "./BoardAccessLog.vue?vue&type=template&id=eb4c9f12&scoped=true"
import script from "./BoardAccessLog.vue?vue&type=script&lang=js"
export * from "./BoardAccessLog.vue?vue&type=script&lang=js"

import "./BoardAccessLog.vue?vue&type=style&index=0&id=eb4c9f12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb4c9f12"]])

export default __exports__